export enum BazaNcBankAccountType {
    CashIn = 'cash-in',
    CashOut = 'cash-out',
}
